import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/home.css';

export default class TourPlace extends Component {
  render() {
    const packages = [
      {
        id: 1,
        title: "2N Munnar - 1N Thekkady - 1N Alappuzha - 1N Cochin",
        duration: "5 Days • 4 Nights",
        price: "From ₹12,999",
        image: "assets/img/places/Munnar.jpg",
        description: "Start your Middle Kerala trip from Cochin to Munnar – one of the most attractive Munnar Hills and Thekkady which offers diverse attractions. Head out to Alleppey – the Venice of the East.",
        highlights: ["Munnar Hills", "Thekkady Wildlife", "Alleppey Backwaters", "Cochin Heritage"],
        link: "/package1"
      },
      {
        id: 2,
        title: "Kerala & Tamilnadu Grand Tour",
        duration: "9 Days • 8 Nights",
        price: "From ₹24,999",
        image: "assets/img/places/kanyakumari.jpg",
        description: "Start your South Kerala & Tamilnadu trip from Kovalam – Paradise of the South. Explore Kanyakumari, Rameswaram, Madurai, Munnar, Thekkady, Alleppey, and Cochin.",
        highlights: ["Kovalam Beach", "Kanyakumari Sunrise", "Rameswaram Temple", "Madurai Meenakshi"],
        link: "/package2"
      },
      {
        id: 3,
        title: "Poorna Group Package",
        duration: "8 Days • 7 Nights",
        price: "From ₹18,999",
        image: "assets/img/places/Kumarakom.jpg",
        description: "Cochin – Munnar – Thekkady – Madurai – Rameswaram - Kanyakumari - Trivandrum - Alleppey – Cochin. Complete South India temple and backwater tour.",
        highlights: ["Temple Tour", "Hill Stations", "Backwaters", "Cultural Experience"],
        link: "/package3"
      }
    ];

    return (
      <div className="packages-section">
        <div className="section-header">
          <h2 className="section-title">Popular Tour Packages</h2>
          <p className="section-subtitle">Discover the beauty of Kerala with our carefully crafted itineraries</p>
        </div>

        <Grid>
          <Row className="packages-grid" style={{ marginRight: '15px', marginLeft: '-15px' }}>
            {packages.map((pkg) => (
              <Col xs={12} sm={6} md={4} key={pkg.id} className="package-col">
                <div className="package-card">
                  <div className="card-image-wrapper">
                    <img 
                      src={pkg.image} 
                      alt={pkg.title}
                      className="card-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://via.placeholder.com/400x300?text=Kerala+Tour";
                      }}
                    />
                    {/* <div className="card-price">{pkg.price}</div> */}
                    <div className="card-badge">{pkg.duration}</div>
                  </div>
                  
                  <div className="card-content">
                    <h3 className="card-title">{pkg.title}</h3>
                    <p className="card-description">{pkg.description}</p>
                    
                    <div className="card-highlights">
                      {pkg.highlights.map((highlight, index) => (
                        <span key={index} className="highlight-tag">{highlight}</span>
                      ))}
                    </div>
                    
                    <Link to={pkg.link} className="explore-btn">
                      <span>Explore Package</span>
                      <svg className="btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          
          <div className="more-packages-wrapper">
            <Link to="/packages" className="more-packages-btn">
              <span>View All Packages</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
        </Grid>
      </div>
    );
  }
}